import { IFeedDataValue } from '@studio/domain/feed';
import { NodeKind } from './nodes';

export const LibraryKind = {
    Rectangle: NodeKind.Rectangle,
    Text: NodeKind.Text,
    Image: NodeKind.Image,
    Video: NodeKind.Video,
    Ellipse: NodeKind.Ellipse,
    Button: NodeKind.Button,
    Widget: NodeKind.Widget,
    Feeds: 'feeds',
    Selection: 'selection',
    Any: 'any'
} as const;

export type LibraryKindValue = (typeof LibraryKind)[keyof typeof LibraryKind];

export interface IFeedFieldListItem {
    id: string;
    name: string;
    values: IFeedDataValue['value'][];
    targetUrls: IFeedDataValue['targetUrl'][];
}

export enum MediaLibraryMode {
    list = 'list',
    grid = 'grid',
    preview = 'preview'
}
